// Unchecked box: border only, in `currentColor`. Geometry matches CheckboxOnIcon exactly -- see
// the note there -- so checking a box never changes its size or its corners.
export default function CheckboxOffIcon({ width = 24, height = 24, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect x='1.2' y='1.2' width='21.6' height='21.6' rx='2.3' fill='none' stroke='currentColor' strokeWidth='2.4' />
    </svg>
  );
}
